import { url as serverUrl } from "./go-versao";

import CryptoJS from "crypto-js";
import { v4 as uuid } from "uuid";

const CENTRAL = "11";
const DEVICE_ID_KEY = "app-name-device-id";

export default class WS {
  constructor(config) {
    Object.assign(this, config);
  }

  static distance(lat1, lon1, lat2, lon2, unit) {
    if (lat1 === lat2 && lon1 === lon2) {
      return 0;
    } else {
      var radlat1 = (Math.PI * lat1) / 180;
      var radlat2 = (Math.PI * lat2) / 180;
      var theta = lon1 - lon2;
      var radtheta = (Math.PI * theta) / 180;
      var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      if (dist > 1) {
        dist = 1;
      }
      dist = Math.acos(dist);
      dist = (dist * 180) / Math.PI;
      dist = dist * 60 * 1.1515;
      if (unit === "K") {
        dist = dist * 1.609344;
      }
      if (unit === "N") {
        dist = dist * 0.8684;
      }
      return dist;
    }
  }

  static async getDeviceId() {
    let deviceId = localStorage.getItem(DEVICE_ID_KEY) || "";
    if (!deviceId) {
      deviceId = uuid();
      localStorage.setItem(DEVICE_ID_KEY, deviceId);
    }
    return deviceId;
  }

  static async validaUsuario(totem, totemnome, uuid, ip, email, nome, telefone) {
    let dados = await WS.callEndpointWithPayload2("totem-getuser", {
      uuid: uuid,
      ip: ip,
      email: email,
      nome: nome,
      fone: telefone,
      totem: totem,
    });
    if (!dados || dados.error) {
      return {};
    } else {
      if (dados) {
        return dados.result;
      } else {
        return {};
      }
    }
  }

  static async resolicitar(uuid, ip, email, nome, telefone, randomCode, idremoto) {
    return WS.callEndpointWithPayload2("presolicitacaoreenviar", {
      uuid: uuid,
      idremoto: idremoto,
      ip: ip,
      email: email,
      nome: nome,
      fone: telefone,
      randomCode: randomCode,
    });
  }

  static async validadeCore(uuid, ip, email, nome, telefone, code, randomCode, idremoto) {
    return WS.callEndpointWithPayload2("presolicitacaoconfirmar", {
      otp_code: code,
      uuid: uuid,
      idremoto: idremoto,
      ip: ip,
      email: email,
      nome: nome,
      fone: telefone,
      randomCode: randomCode,
    });
  }

  static async requestCode(totem, totem_name, uuid, ip, email, nome, telefone) {
    let dados = await WS.callEndpointWithPayload2("otp-sms", {
      totem_name: totem_name,
      totem: totem,
      uuid: uuid,
      ip: ip,
      email: email,
      nome: nome,
      fone: telefone,
    });
    if (!dados || dados.error) {
      return {};
    } else {
      if (dados) {
        return dados.result;
      } else {
        return {};
      }
    }
  }

  static async gpsnovo(coords) {
    //console.log('autocomplete',{address: address,coords:coords, data:new Date()})

    console.log("autocomplete gpsnovo", coords);

    let dados = await WS.callEndpointWithPayload2("reverse", {
      lat: coords.latitude,
      lon: coords.longitude,
    });
    if (!dados || dados.error) {
      return {};
    } else {
      if (dados) {
        return dados.result;
      } else {
        return {};
      }
    }
  }

  static getUserIp() {
    return fetch("https://api.ipify.org?format=json") // Example using ipify.org
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((error) => {
        console.error("Error fetching IP:", error);
        return { ip: "" };
      });
  }

  static callEndpointWithPayload2(method, parameters) {
    parameters.central = CENTRAL;
    let payload = {
      method: method,
      parameters: parameters,
    };

    let ciphertext = CryptoJS.AES.encrypt(JSON.stringify(payload), "secretAppcGo").toString();

    console.log(method, parameters);
    return fetch(serverUrl + "/cryptoclient", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-central-id": CENTRAL,
      },
      body: JSON.stringify({ method: method, payload: ciphertext }),
    })
      .then(async (response) => {
        let saida = await response.json();

        let bytes = CryptoJS.AES.decrypt(saida.data, "secretAppcGo");

        let dados = await JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        console.log(method, dados);
        return dados;
      })
      .catch((error) => {
        console.log(method, error);
      });
  }

  static async directions(origin, destination) {
    let dados = await WS.callEndpointWithPayload2("osm-route", {
      origin: origin,
      destination: destination,
    });
    if (dados) {
      return dados.result;
    } else {
      return null;
    }
  }
  static async placeidserver(place, texto, lat, lon) {
    let dados = await WS.callEndpointWithPayload2("places", {
      place: place,
      texto: texto,
      lat: lat,
      lon: lon,
    });
    if (!dados) {
      return {};
    } else {
      if (dados) {
        return dados.result;
      } else {
        return {};
      }
    }
  }
  static async autocomplete(address, coords) {
    let dados = await WS.callEndpointWithPayload2("autocomplete", {
      address: address,
      latitude: coords.latitude,
      longitude: coords.longitude,
    });
    if (!dados) {
      return [];
    } else {
      if (dados) {
        return dados.result;
      } else {
        return [];
      }
    }
  }
  static async totem(id) {
    let dados = await WS.callEndpointWithPayload2("totem", {
      id: id,
    });
    if (!dados) {
      return {};
    } else {
      if (dados) {
        return dados.result;
      } else {
        return {};
      }
    }
  }

  static async calcValor(origem, destinos, totem) {
    let data = { waypoints: [] };
    data.empresa = 0;
    data.funcionario = 0;
    data.departamento = 0;
    data.totem = totem.codigo;
    data.dois_tokes = true;
    data.waypoints.push({
      latitude: origem.latitude,
      longitude: origem.longitude,
    });

    for (let index = 0; index < destinos.length; index++) {
      const element = destinos[index];
      data.waypoints.push({
        latitude: element.latitude,
        longitude: element.longitude,
      });
    }
    let dados = await WS.callEndpointWithPayload2("calcula_valor", data);

    if (!dados) {
      return {};
    } else {
      if (dados) {
        return dados.result;
      } else {
        return {};
      }
    }
  }

  static async preSolicitar(origem, destinos, pagamento, cliente, totem) {
    try {
      let data = { waypoints: [] };
      data.promocode = "";
      data.empresa = 0;
      data.central = CENTRAL;
      data.funcionario = 0;
      data.departamento = 0;
      data.uuid = cliente.idremoto;
      data.cdpagamento = pagamento;
      data.email = cliente.email;
      data.totem_name = totem.nome;
      data.telefone = cliente.telefone;
      data.sms = cliente.telefone;
      data.nome = cliente.nome;
      data.observacoes = "";
      data.numero_carros = 1;
      data.passageiros = 1;
      data.totem = totem.codigo;
      data.dois_tokes = true;
      data.atendente = "2toques_app";

      data.waypoints.push({
        latitude: origem.latitude,
        longitude: origem.longitude,
        linha: !!origem.linha ? origem.linha : origem.fullAddress,
        obs: "",
      });

      for (let index = 0; index < destinos.length; index++) {
        const element = destinos[index];
        data.waypoints.push({
          latitude: element.latitude,
          longitude: element.longitude,
          linha: !!element.linha ? element.linha : element.fullAddress,
        });
      }

      return WS.callEndpointWithPayload2("presolicitacao", data);
    } catch (e) {
      console.log(e);
      return { error: true };
    }
  }
}
